/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Req_QInputs */

const en_wc_faq_req_q = /** @type {(inputs: Wc_Faq_Req_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are the WordCraft system requirements?`)
};

/**
* | output |
* | --- |
* | "What are the WordCraft system requirements?" |
*
* @param {Wc_Faq_Req_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_req_q = /** @type {((inputs?: Wc_Faq_Req_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Req_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_req_q(inputs)
});
export { wc_faq_req_q as "wc.faq.req.q" }